/** @format */

import React, { PureComponent } from 'react';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import I18n from '../../../components/Translate/I18n';
import adescomStyle from '../../../assets/jss/adescom/adescomStyle';
import withStyles from '@material-ui/core/styles/withStyles';
import { Typography } from '@material-ui/core';
import { DateHelper } from '../../../helpers/DateHelper';
import Card from '../../../components/Card/Card.jsx';
import CardBody from '../../../components/Card/CardBody.jsx';
import CardHeader from '../../../components/Card/CardHeader';
import CardHeaderExt from '../../../components/Heading/CardHeaderExt';
import { store } from '../../../core/store';
import { provisioningReducers } from '../../../modules/provisioning/reducers';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import Filter from '../../../interfaces/forms/Filter';
import Order from '../../../interfaces/forms/Order';
import MvnoBlockRequest from '../../../interfaces/platform/MvnoBlockRequest';
import MvnoBlockRequestState from '../../../interfaces/platform/MvnoBlockRequestState';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import ApiCollectionResponseInterface from '../../../interfaces/api/ApiCollectionResponseInterface';
import BlockRequestStateListItem from './BlockRequestStateListItem';
import MvnoBlockContainsView from '../../Block/MvnoBlockContainsView';
import { MvnoBlockFunctionsCollection } from '../../../modules/block/BlockContainHelper';
import Storage from '@material-ui/icons/Storage';
import MvnoBlockContain                  from '../../../interfaces/platform/MvnoBlockContain';
import BlockViewController               from '../../Block/BlockViewController';
import ApiDialog                         from '../components/ApiDialog';
import { ConfigWrapper }                 from '../../../core/ConfigWrapper';
import PlatformResellerInterface         from '../../../interfaces/platform/PlatformResellerInterface';
import { PlatformResellerLoader }        from '../../../modules/platformreseller/PlatformResellerLoader';
import { MvnoBlockListLoader }           from '../../../modules/block/MvnoBlockListLoader';
import MvnoBlockListInterface            from '../../../interfaces/platform/MvnoBlockListInterface';
import { MvnoBlockFunctionLoader }       from '../../../modules/block/MvnoBlockFunctionLoader';
import { operationStatus }               from '../../../modules/block/OperationStatus';
import { provConstant, ProvReducerType } from '../../../modules/provisioning/ProvisioningConnect';
import COLORS                            from "../../../assets/themes/OPL/colors";

interface MvnoBlockRequestCollection extends ApiCollectionResponseInterface {
    readonly 'hydra:member': Array<MvnoBlockRequestState> | null;
}

interface BlockViewProps {
    dispatch: any;
    classes: any;
    match: any;
    reload?: boolean;
    type?: string;

    showMainLoader(show: boolean): void;
}

interface BlockViewState {
    filters: Array<Filter>;
    orders: Array<Order>;
    blockStateList: MvnoBlockRequestCollection | null;
    blockFunctionList: MvnoBlockFunctionsCollection | null;
    viewItem: MvnoBlockRequest | null;
    containFunctions: Array<MvnoBlockContain> | null;
    viewDialog: boolean;
    viewContent: any | null;
    viewTitle: any | string | null;
    platformReseller: PlatformResellerInterface | null;
    mvnoBlockList: MvnoBlockListInterface | null;
}

class BlockView extends PureComponent<BlockViewProps, BlockViewState> {
    private itemLoader: ItemLoaders;
    private paramsId: number;
    private configWrapper: ConfigWrapper;
    private platformResellerLoader: PlatformResellerLoader;
    private mvnoBlockListLoader: MvnoBlockListLoader;
    private mvnoBlockFunctionLoader: MvnoBlockFunctionLoader;

    constructor(props: BlockViewProps, state: BlockViewState) {
        super(props, state);

        store.injectReducer('provisioningReducers', provisioningReducers);
        this.state = {
            filters: [],
            orders: [{ name: 'id', value: 'ASC' }],
            blockStateList: null,
            blockFunctionList: null,
            viewItem: null,
            containFunctions: null,
            viewContent: null,
            viewDialog: false,
            viewTitle: null,
            platformReseller: null,
            mvnoBlockList: null,
        };
        this.itemLoader = new ItemLoaders(this.props.dispatch);
        this.paramsId = 0;
        this.configWrapper = new ConfigWrapper();
        this.platformResellerLoader = new PlatformResellerLoader(this.itemLoader);
        this.mvnoBlockListLoader = new MvnoBlockListLoader(this.itemLoader);
        this.mvnoBlockFunctionLoader = new MvnoBlockFunctionLoader(this.itemLoader);
    }

    componentDidMount(): void {
        this.mvnoBlockFunctionLoader.loadCollection((data: MvnoBlockFunctionsCollection) => {
            this.setState({ blockFunctionList: data });
        });
        this.getStateList();
    }

    componentDidUpdate(prevProps: Readonly<BlockViewProps>, prevState: Readonly<BlockViewState>, snapshot?: any): void {
        const { dispatch, reload, type } = this.props;
        if (this.props.match.params.id !== prevProps.match.params.id) {
            this.setState(
                {
                    viewItem: null,
                    blockStateList: null,
                },
                this.getStateList
            );
        }
        if (reload && type === provConstant.MVNO_BLOCK_VIEW_RELOAD) {
            dispatch({
                type: provConstant.MVNO_BLOCK_VIEW_RELOAD,
                reload: false,
            });
            this.reloadViewBlock();
        }
    }

    setContainFunction = (containFunctions: Array<MvnoBlockContain>): void => this.setState({ containFunctions: containFunctions });

    getStateList = (): void => {
        const { match, showMainLoader } = this.props;
        this.paramsId = match.params.id;
        const url = FormGeneralHelper.getByUri('/' + this.paramsId);
        showMainLoader(true);
        this.itemLoader.getWithCallback(
            url,
            'request_mvno_block_request_callback',
            (data: MvnoBlockRequest): void => {
                this.setState(
                    {
                        viewItem: data,
                        filters: [{ name: 'mvnoBlockRequestId', value: data.id }],
                    },
                    (): void => {
                        const { filters, orders } = this.state;
                        if (data.platformResellerId) {
                            this.platformResellerLoader.loadPlatformResellerById(data.platformResellerId, (data: PlatformResellerInterface) => {
                                this.setState({ platformReseller: data });
                            });
                        }
                        this.mvnoBlockListLoader.loadItem(data.mvnoBlockListId, (data: MvnoBlockListInterface) => {
                            this.setState({ mvnoBlockList: data });
                        });
                        this.itemLoader.getListWithCallback(
                            FormGeneralHelper.getUrl('/mvno_block_request_states'),
                            'request_state_list_callback',
                            filters,
                            orders,
                            (data: MvnoBlockRequestCollection) => {
                                this.setState({ blockStateList: data });
                            },
                            { dispatchAfterCallback: false, propagateDataToCallback: true, dispatchErrorAfterCallback: true }
                        );
                        showMainLoader(false);
                    }
                );
            },
            { propagateDataToCallback: true, dispatchErrorAfterCallback: true, dispatchAfterCallback: false }
        );
    };

    reloadViewBlock = (): void => this.setState({ viewItem: null }, this.getStateList);

    viewDialog = (title: any | string | null, content: any | null): void =>
        this.setState({
            viewDialog: true,
            viewContent: content,
            viewTitle: title,
        });
    hideDialog = (): void => this.setState({ viewDialog: false, viewContent: null });

    render(): React.ReactNode {
        const { showMainLoader } = this.props;
        const {
            blockStateList,
            blockFunctionList,
            viewItem,
            containFunctions,
            viewContent,
            viewDialog,
            viewTitle,
            platformReseller,
            mvnoBlockList,
        } = this.state;
        const size = 6;
        const variant = 'subtitle2';

        if (viewItem) {
            return (
                <GridContainer>
                    <GridItem xs={12} md={12} lg={12}>
                        <Card>
                            <CardHeaderExt icon={<Storage />} trans="prov:list.view_block_request" />
                            <CardBody>
                                <GridContainer>
                                    <GridItem xs={size}>
                                        <GridContainer>
                                            <GridItem xs={size}>
                                                <Typography variant={variant}>
                                                    <I18n trans="prov:list.id" />
                                                </Typography>
                                            </GridItem>
                                            <GridItem xs={size}>{viewItem.id}</GridItem>
                                            <GridItem xs={size}>
                                                <Typography variant={variant}>
                                                    <I18n trans="prov:list.partner" />
                                                </Typography>
                                            </GridItem>
                                            <GridItem xs={size}>{platformReseller?.mainname}</GridItem>
                                            <GridItem xs={size}>
                                                <Typography variant={variant}>
                                                    <I18n trans="prov:list.block" />
                                                </Typography>
                                            </GridItem>
                                            <GridItem xs={size}>{mvnoBlockList && <I18n trans={'prov:b.' + mvnoBlockList.blockName} />}</GridItem>
                                            <GridItem xs={size}>
                                                <Typography variant={variant}>
                                                    <I18n trans="prov:list.msisdn" />
                                                </Typography>
                                            </GridItem>
                                            <GridItem xs={size}>{viewItem.msisdn}</GridItem>
                                            <GridItem xs={size}>
                                                <Typography variant={variant}>
                                                    <I18n trans="prov:list.request_path" />
                                                </Typography>
                                            </GridItem>
                                            <GridItem xs={size}>
                                                {viewItem.mvnoBlockApiRequestId && !viewItem.calledFromBlockId && (
                                                    <React.Fragment>
                                                        <I18n trans="prov:list.request_path_api" />
                                                    </React.Fragment>
                                                )}
                                                {!viewItem.mvnoBlockApiRequestId && !viewItem.calledFromBlockId && (
                                                    <React.Fragment>
                                                        <I18n trans="prov:list.request_path_www" />
                                                    </React.Fragment>
                                                )}
                                                {viewItem.mvnoBlockRequestPrevId && !viewItem.calledFromBlockId && (
                                                    <React.Fragment>
                                                        (<I18n trans="prov:list.request_renew_block" />)
                                                    </React.Fragment>
                                                )}
                                                {viewItem.calledFromBlockId && viewItem.mvnoBlockApiRequestId && (
                                                    <React.Fragment>
                                                        <I18n trans="prov:list.request_path_api" /> /
                                                        <I18n trans="prov:list.request_path_from_block" />
                                                    </React.Fragment>
                                                )}
                                                {viewItem.calledFromBlockId && !viewItem.mvnoBlockApiRequestId && (
                                                    <React.Fragment>
                                                        <I18n trans="prov:list.request_path_www" /> /
                                                        <I18n trans="prov:list.request_path_from_block" />
                                                    </React.Fragment>
                                                )}
                                            </GridItem>
                                        </GridContainer>
                                    </GridItem>
                                    <GridItem xs={size}>
                                        <GridContainer>
                                            <GridItem xs={size}>
                                                <Typography variant={variant}>
                                                    <I18n trans="prov:b.created_at" />
                                                </Typography>
                                            </GridItem>
                                            <GridItem xs={size}>{DateHelper.format(viewItem.createdAt)}</GridItem>
                                            <GridItem xs={size}>
                                                <Typography variant={variant}>
                                                    <I18n trans="prov:list.block_start" />
                                                </Typography>
                                            </GridItem>
                                            <GridItem xs={size}>{DateHelper.format(viewItem.startProcessAt)}</GridItem>
                                            <GridItem xs={size}>
                                                <Typography variant={variant}>
                                                    <I18n trans="prov:list.block_end" />
                                                </Typography>
                                            </GridItem>
                                            <GridItem xs={size}>{viewItem.requestEnd && DateHelper.format(viewItem.lastRequestProcessed)}</GridItem>
                                            {viewItem.requestEnd && viewItem.errorState && viewItem.operationStatus === null && (
                                                <GridItem xs={12}>
                                                    <span style={{color: COLORS.FUNCTION.DANGER}}><I18n trans="prov:view.end_with_error" /></span>
                                                </GridItem>
                                            )}
                                            {viewItem.requestEnd &&
                                                viewItem.errorState &&
                                                viewItem.operationStatus === operationStatus.OPERATION_STATUS_BREAK_ERROR_STOP && (
                                                    <GridItem xs={12}>
                                                        <span style={{color: COLORS.FUNCTION.DANGER}}>
                                                            <I18n trans="prov:view.block_terminate_in_error_state" />
                                                        </span>
                                                    </GridItem>
                                                )}
                                            {viewItem.requestEnd && viewItem.operationStatus === operationStatus.OPERATION_STATUS_BREAK_OK_STOP && (
                                                <GridItem xs={12}>
                                                    <span style={{color: COLORS.MAIN.PRIMARY}}>
                                                        <I18n trans="prov:view.block_terminate_correctly_state" />
                                                    </span>
                                                </GridItem>
                                            )}
                                            {viewItem.requestEnd &&
                                                viewItem.errorState &&
                                                viewItem.version >= this.configWrapper.getMaxVersionOnBlock() && (
                                                    <GridItem xs={12}>
                                                        <span style={{color: COLORS.FUNCTION.DANGER}}>
                                                            <I18n trans="prov:view.end_with_hit_max_version" />
                                                        </span>
                                                    </GridItem>
                                                )}
                                        </GridContainer>
                                    </GridItem>
                                    <GridItem xs={12}>
                                        <MvnoBlockContainsView
                                            mvnoBlockListId={viewItem.mvnoBlockListId}
                                            blockFunctionList={blockFunctionList}
                                            setContainFunction={this.setContainFunction}
                                            hideView={false}
                                        />
                                    </GridItem>
                                    <GridItem xs={12} style={{marginTop: 15}}>
                                        <BlockViewController
                                            showMainLoader={showMainLoader}
                                            mvnoBlockRequest={viewItem}
                                            reloadViewBlock={this.reloadViewBlock}
                                            viewDialog={this.viewDialog}
                                        />
                                    </GridItem>
                                    {blockStateList && containFunctions && blockFunctionList && (
                                        <GridItem xs={12}>
                                            <Card style={{paddingLeft:0}}>
                                                <CardHeader>
                                                    <Typography variant={variant}>
                                                        <I18n trans="prov:list.block_request_states" />
                                                    </Typography>
                                                </CardHeader>
                                                <CardBody xs={12}>
                                                    {blockStateList['hydra:member'] &&
                                                        blockStateList['hydra:member'].map((stateItem: MvnoBlockRequestState) => {
                                                            return (
                                                                <BlockRequestStateListItem
                                                                    key={'mvno_block_request_state_' + stateItem.id}
                                                                    mvnoBlockRequestState={stateItem}
                                                                    blockFunctionList={blockFunctionList}
                                                                    containFunctions={containFunctions}
                                                                    viewDialog={this.viewDialog}
                                                                    mvnoBlockRequest={viewItem}
                                                                />
                                                            );
                                                        })}
                                                </CardBody>
                                            </Card>
                                        </GridItem>
                                    )}
                                </GridContainer>
                            </CardBody>
                        </Card>
                        <ApiDialog open={viewDialog} fullWidth={true} closeCallback={this.hideDialog} content={viewContent} title={viewTitle} />
                    </GridItem>
                </GridContainer>
            );
        }
        return null;
    }
}

const stateToProps = (state: { provReducer: ProvReducerType }): object => {
    const { provReducer } = state;
    if (provReducer && provReducer.type === provConstant.MVNO_BLOCK_VIEW_RELOAD && provReducer.reload) {
        return {
            reload: true,
            type: provConstant.MVNO_BLOCK_VIEW_RELOAD,
        };
    }
    return {};
};
export default compose<any, any>(connect(stateToProps), withStyles(adescomStyle))(BlockView);
